import React from 'react';
import './style/main.scss';
import FrontPage from './FrontPage';

function App() {
  return (<FrontPage/>)
}

export default App;
